import { UseNavigateResult } from '@tanstack/react-router';
import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';
import { documentLivenessEndpointPOST } from '~/api/def/endpoints/document/documentLivenessEndpoint';
import { documentRestatedEndpointPOST } from '~/api/def/endpoints/document/documentRestatedEndpoint';

export const getObligationsContextMenu = (
  params: GetContextMenuItemsParams,
  navigate: UseNavigateResult<string>,
): (string | MenuItemDef)[] => {
  const result: (string | MenuItemDef)[] = [
    {
      name: 'Go to Clause',
      action: async () => {
        if (params?.node?.data?.documentId && params?.node?.data?.clauseId)
          navigate({
            to: `/obligations/clause/${params.node.data.documentId}/${params.node.data.clauseId}`,
          });
      },
      disabled: !(
        params?.node?.data?.documentId && params?.node?.data?.clauseId
      ),
      cssClasses: ['red', 'bold'],
    },
    {
      name: 'Toggle Document Liveness',
      action: async () => {
        if (params?.node?.data?.id)
          await documentLivenessEndpointPOST('/' + params.node.data.id, {
            documentId: params.node.data.id,
            liveness: !params.node.data.liveness,
          });
      },
      disabled: !params?.node?.data?.id,
      cssClasses: ['red', 'bold'],
    },
    {
      name: `${params?.node?.data?.restated ? 'Unset restated' : 'Restate Agreement'}`,
      action: async () => {
        if (params?.node?.data?.id)
          await documentRestatedEndpointPOST('/' + params.node.data.id, {
            documentId: params.node.data.id,
            restated: !params?.node?.data?.restated,
          });
      },
      disabled: !params?.node?.data?.id,
    },
    'separator',
    'paste',
    'copy',
    'separator',
    'autoSizeAll',
    'excelExport',
    'copyWithHeaders',
    'csvExport',
  ];
  return result;
};
